import NavigationLayout from "./NavigationLayout";
import AdvisorDrawerContent, {
  NotificationBadgedButton,
} from "./AdvisorDrawerContent";
import { AccountType } from "protogen/common_pb";
import { AddCallContext } from "components/context/AddCallContext";
import { VideoCallContextProvider } from "components/context/VideoCallContext";
import SearchContextProvider from "components/context/SearchContextProvider";
import StatusContextProvider from "components/context/StatusContextProvider";
import { SnackpackContextProvider } from "components/context/SnackpackContextProvider";
import SocketConsumerProvider from "components/context/SocketConsumerProvider";
import { TimeRecorderContextProvider } from "components/context/TimeRecorderContext";

export default () => {
  return (
    <NavigationLayout
      drawerContent={AdvisorDrawerContent}
      MobileBadgerComponent={NotificationBadgedButton}
      loginRedirectPath="/login"
      tosAccountType={AccountType.ADVISOR}
      authedContexts={[
        SocketConsumerProvider,
        StatusContextProvider,
        AddCallContext,
        VideoCallContextProvider,
        SearchContextProvider,
        SnackpackContextProvider,
        TimeRecorderContextProvider,
      ]}
    />
  );
};
